import request from '@/utils/request'

const pre = '/system/ai/provider'

// 列表查询（按用途筛选可选）
export function reqAiProviderList(purpose) {
    return request({
        url: pre + '/list',
        method: 'get',
        params: purpose ? { purpose } : {}
    })
}

// 详情
export function reqAiProviderDetail(id) {
    return request({
        url: pre + '/detail',
        method: 'get',
        params: { id }
    })
}

// 新增
export function reqAiProviderInsert(data) {
    return request({
        url: pre + '/insert',
        method: 'post',
        data
    })
}

// 更新
export function reqAiProviderUpdate(data) {
    return request({
        url: pre + '/update',
        method: 'post',
        data
    })
}

// 删除
export function reqAiProviderDelete(id) {
    return request({
        url: pre + '/delete',
        method: 'get',
        params: { id }
    })
}

// 连通性测试
export function reqAiProviderTest(id) {
    return request({
        url: pre + '/test',
        method: 'get',
        params: { id },
        timeout: 60000
    })
}

// 复制配置为新场景用途（同接口/密钥，仅 purpose 不同）
export function reqAiProviderCopy(params) {
    return request({
        url: pre + '/copy',
        method: 'post',
        params
    })
}
